<div class="p-fluid class-loading">
    <div class="p-grid p-jc-md-center mt-5">
        <img src="./assets/app/SplashScreen.png" class="img-splash mt-4" alt="">
    </div>
</div>

 